(function(){
  // ------- helpers -------
  function $(s, r){return (r||document).querySelector(s);}
  function $all(s, r){return Array.from((r||document).querySelectorAll(s));}
  function val(name){const el=$(`[name="${name}"]`);return el?el.value.trim():'';}
  async function saveAttributes(attrs){
    const fd = new FormData();

    // ① 拡張属性（cart attributes）を追加
    Object.keys(attrs).forEach(k => {
      fd.append(`attributes[${k}]`, attrs[k] ?? '');
    });

    // ② cart note も一緒に送る
    const noteField = document.querySelector('[name="note"]');
    if (noteField) {
      fd.append('note', noteField.value || '');
    }

    const res = await fetch('/cart/update.js', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) throw new Error('Failed to save cart attributes / note');
  }
  function setMinDateJST(input, days){
    const now = new Date();
    const jst = new Date(now.getTime() + (9*60 - now.getTimezoneOffset())*60000);
    jst.setHours(0,0,0,0);
    jst.setDate(jst.getDate() + Number(days||0));
    const yyyy=jst.getFullYear(), mm=String(jst.getMonth()+1).padStart(2,'0'), dd=String(jst.getDate()).padStart(2,'0');
    input.min = `${yyyy}-${mm}-${dd}`;
  }

  async function hasIntlInCartLive(){
    try{
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }});
      const data = await res.json();
      return (data.items || []).some(it=>{
        const t = (it.product_title + ' ' + (it.title||'') + ' ' + (it.variant_title||'')).toLowerCase();
        return t.includes('international shipping');
      });
    }catch(e){
      console.warn('cart.js fetch failed', e);
      return false;
    }
  }

  function showPanel(key){
  const root = $('#physical-delivery-block'); if(!root) return;
  $all('.delivery-panel', root).forEach(p=>{
    p.hidden = p.getAttribute('data-panel') !== key;
  });
  // 表示直後にカレンダーを初期化/再設定（未初期化は初期化、初期化済はminDate再適用）
  if (typeof initDatePickersEn === 'function') initDatePickersEn();
  }
  function requireFieldsForPhysical(key){
    if(key==='Ship to Hotel in Japan'){
      return [
        ['attributes[HOTEL NAME]','Hotel Name'],
        ['attributes[CHECK IN DATE]','Check-in date'],
        ['attributes[RESERVATION NAME]','Reservation Name']
      ];
    }
    if(key==='Post Office Pick-up'){
      return [
        ['attributes[POST OFFICE]','Post Office'],
        ['attributes[POST OFFICE RECIPIENT NAME]','Recipient’s full name'],
        ['attributes[PICK UP DATE]','Scheduled pick-up date']
      ];
    }
    if(key==='International Shipping'){
      return [
        ['attributes[SHIPPING COUNTRY]','Shipping country'],
        ['attributes[SHIPPING ADDRESS]','FULL Shipping address'],
        ['attributes[POSTAL CODE]','Postal code'],
        ['attributes[RECIPIENT_NAME]','Name'],
        ['attributes[PHONE NUMBER]','Phone number'],
        ['attributes[DEPARTURE DATE]','Departure date from delivery location']
      ];
    }
    if(key==='Ship to Address in Japan'){
      return [
        ['attributes[SHIPPING ADDRESS in JAPAN]','Shipping address'],
        ['attributes[JAPAN POSTAL CODE]','Postal code'],
        ['attributes[RECIPIENT NAME in JAPAN]','Name'],
        ['attributes[DELIVERED BY]','Delivered by date']
      ];
    }
    return [];
  }

  const PHYSICAL_ATTR_KEYS = [
    'Delivery option',
    'HOTEL NAME',
    'CHECK IN DATE',
    'RESERVATION NAME',
    'HOTEL RESERVATION NUMBER',
    'HOTEL ADDRESS',
    'POST OFFICE',
    'POST OFFICE RECIPIENT NAME',
    'PICK UP DATE',
    'SHIPPING COUNTRY',
    'SHIPPING ADDRESS',
    'POSTAL CODE',
    'RECIPIENT_NAME',
    'PHONE NUMBER',
    'DEPARTURE DATE',
    'SHIPPING ADDRESS in JAPAN',
    'JAPAN POSTAL CODE',
    'RECIPIENT NAME in JAPAN',
    'DELIVERED BY'
  ];

  const EMAIL_ATTR_KEYS = [
    'REPRESENTATIVE NAME',
    'Date of Birth'
  ];


  // ------- Email block: DOB 初期月（1980-01）トリック -------
  function initEmailBlock(){
    if (typeof flatpickr !== 'undefined') return;
    const dob = $('#rep_dob_input');
    if(!dob) return;
    const initMonth = dob.getAttribute('data-initial-month'); // "1980-01"
    if(!initMonth) return;
    dob.addEventListener('focus', function(){
      if(dob.value) return;
      try{
        dob.value = initMonth + '-01';
        if(dob.showPicker) dob.showPicker();
        setTimeout(function(){
          if(document.activeElement !== dob && dob.value === initMonth + '-01'){
            dob.value = '';
          }
        }, 250);
      }catch(e){}
    });
  }

  // ------- Physical block -------
  function initPhysicalBlock(){
    const block = $('#physical-delivery-block'); 
    if (!block) return;

    const select = $('#delivery_option_select', block);
    if (!select) return;  // ← この1行を追加

    // パネル切替 + intl選択時はライブ判定 → 必要ならポップアップ
    select.addEventListener('change', async ()=>{
    const key = select.value || '';
    showPanel(key);

    if (key === 'International Shipping'){
      const liveHas = await hasIntlInCartLive();
      const modal = $('#intlModal', block);
      if (!liveHas && modal){
        modal.style.display = 'flex';
      }
    }
  });

  // 既存値があれば復元（読み込み直後）
  if (select.value){ showPanel(select.value); }

  // モーダル クローズ
  const intlPanel   = $('.delivery-panel[data-panel="International Shipping"]', block);
  const modalOverlay= intlPanel && $('#intlModal', intlPanel);
  const modalClose  = intlPanel && $('.modal-close', intlPanel);
  if (modalOverlay && modalClose){
    modalClose.addEventListener('click', ()=>{ modalOverlay.style.display = 'none'; });
  }
  }


  // ------- Checkout 統合ガード（Email / Physical 両対応） -------
  function initCheckoutGuard(){
    const root = $('#cart-extra-forms'); if (!root) return;
    const hasEmail    = root.getAttribute('data-has-email') === 'true';
    const hasPhysical = root.getAttribute('data-has-physical') === 'true';

    const checkoutButtons = $all(
      'form[action="/cart"] [name="checkout"], .cart__checkout, button[name="checkout"], a[href*="/checkout"]'
    );

    checkoutButtons.forEach(btn => {
      btn.addEventListener('click', async (e) => {
        // ★ まず必ずブラウザのデフォルト送信を止める
        e.preventDefault();

        const errors  = [];
        const payload = {};

        // --- Email 必須 ---
        if (hasEmail) {
          const name = val('attributes[REPRESENTATIVE NAME]');
          const dob  = val('attributes[Date of Birth]');
          if (!name) errors.push('Name of travel representative');
          if (!dob)  errors.push('Date of birth of travel representative');
          payload['REPRESENTATIVE NAME'] = name;
          payload['Date of Birth']            = dob;
        }

        // --- Physical 必須 ---
        if (hasPhysical) {
          const block  = $('#physical-delivery-block');
          const select = $('#delivery_option_select', block);

          if (!select || !select.value) {
            errors.push('Delivery option');
          } else {
            payload['Delivery option'] = select.value;

            // ★ International Shipping 商品ガード（ライブ判定）
            if (select.value === 'International Shipping') {
              const liveHas = await hasIntlInCartLive();  // /cart.js から現在のカートを確認
              if (!liveHas) {
                const modal = $('#intlModal', block);
                if (modal) modal.style.display = 'flex';
                // Intl 商品が無い場合はここで終了（/checkout へ進まない）
                return;
              }
            }

            // 面ごとの必須項目
            const reqs = requireFieldsForPhysical(select.value);
            reqs.forEach(([n, label]) => { if (!val(n)) errors.push(label); });

            // payload へ面の値を集約
            if (select.value === 'Ship to Hotel in Japan') {
              payload['HOTEL NAME']             = val('attributes[HOTEL NAME]');
              payload['CHECK IN DATE']          = val('attributes[CHECK IN DATE]');
              payload['RESERVATION NAME']       = val('attributes[RESERVATION NAME]');
              payload['HOTEL RESERVATION NUMBER']=val('attributes[HOTEL RESERVATION NUMBER]');
              payload['HOTEL ADDRESS']          = val('attributes[HOTEL ADDRESS]');
            } else if (select.value === 'Post Office Pick-up') {
              payload['POST OFFICE']                = val('attributes[POST OFFICE]');
              payload['POST OFFICE RECIPIENT NAME'] = val('attributes[POST OFFICE RECIPIENT NAME]');
              payload['PICK UP DATE']               = val('attributes[PICK UP DATE]');
            } else if (select.value === 'International Shipping') {
              payload['SHIPPING COUNTRY']          = val('attributes[SHIPPING COUNTRY]');
              payload['SHIPPING ADDRESS']          = val('attributes[SHIPPING ADDRESS]');
              payload['POSTAL CODE']               = val('attributes[POSTAL CODE]');
              payload['RECIPIENT_NAME']            = val('attributes[RECIPIENT_NAME]');
              payload['PHONE NUMBER']              = val('attributes[PHONE NUMBER]');
              payload['DEPARTURE DATE']            = val('attributes[DEPARTURE DATE]');
            } else if (select.value === 'Ship to Address in Japan') {
              payload['SHIPPING ADDRESS in JAPAN'] = val('attributes[SHIPPING ADDRESS in JAPAN]');
              payload['JAPAN POSTAL CODE']         = val('attributes[JAPAN POSTAL CODE]');
              payload['RECIPIENT NAME in JAPAN']   = val('attributes[RECIPIENT NAME in JAPAN]');
              payload['DELIVERED BY']              = val('attributes[DELIVERED BY]');
            }
          }
        }

        // --- エラーがあればアラートして終了（/checkout には行かない） ---
        if (errors.length) {
          alert('Please fill in:\n- ' + errors.join('\n- '));
          return;
        }

        // --- QR / Email 用 attributes のスナップショット ---
        // hasEmail = true なら「今回 payload に入っていない QR 用キー」は空文字で上書き
        // hasEmail = false なら QR 用キーは全部空文字でクリア
        EMAIL_ATTR_KEYS.forEach((k) => {
          if (!hasEmail || !(k in payload)) {
            payload[k] = '';
          }
        });

        // --- Physical / Delivery 用 attributes のスナップショット ---
        // hasPhysical = true なら「今回 payload に入っていない配送キー」は空文字で上書き
        // hasPhysical = false なら配送キーは全部空文字でクリア
        PHYSICAL_ATTR_KEYS.forEach((k) => {
          if (!hasPhysical || !(k in payload)) {
            payload[k] = '';
          }
        });

        // --- ここまで来たら cart attributes 保存 → 手動で /checkout へ遷移 ---
        try {
          await saveAttributes(payload);
          window.location.href = '/checkout';
        } catch (err) {
          console.error(err);
          alert('An error occurred while saving. Please reload and try again.');
        }


      }, { capture: true });
    });
  }


 

function initDatePickersEn(){
  if (typeof flatpickr === 'undefined') return;

  // JSTの今日+n日
  function jstDatePlus(days){
    const now = new Date();
    const jst = new Date(now.getTime() + (9*60 - now.getTimezoneOffset())*60000);
    jst.setHours(0,0,0,0);
    jst.setDate(jst.getDate() + Number(days||0));
    return jst;
  }

  document.querySelectorAll('input.date-en').forEach(function(input){
    // すでに初期化済みならスキップ（重複防止）
    if (input._fp) return;

    const minDays = Number(input.getAttribute('data-min-days') || 0);
    const minDate = minDays ? jstDatePlus(minDays) : null;
    const initialMonth = input.getAttribute('data-initial-month'); // "1980-01" など

    const fp = flatpickr(input, {
      // ★★ モバイルでも Flatpickr を強制表示 ★★
      disableMobile: true,
      clickOpens: true,
      allowInput: false,

      // 表示英語 / 
      dateFormat: "F j Y",
      defaultDate: input.value || undefined,
      minDate: minDate || undefined,

      // オーバーレイが親のCSSにクリップされないよう body に付ける
      appendTo: document.body,
      position: "auto", // or "below"

      onReady: function(selectedDates, dateStr, instance){
        // 値が空で初期表示月がある場合はその月へジャンプ
        if (!dateStr && initialMonth){
          const [y,m] = initialMonth.split('-');
          instance.jumpToDate(new Date(Number(y), Number(m)-1, 1));
        }
      }
    });

    // 参照用に保持（2重初期化防止）
    input._fp = fp;

    // フォーカス時に確実に開く（モバイルSafari対策）
    input.addEventListener('focus', function(){
      if (input.readOnly && fp) fp.open();
    });
    input.addEventListener('click', function(){
      if (fp) fp.open();
    });
  });

  // z-index 競合対策（テーマのオーバーレイより手前に出す）
  if (!document.getElementById('flatpickr-zfix')) {
    const style = document.createElement('style');
    style.id = 'flatpickr-zfix';
    style.textContent = '.flatpickr-calendar { z-index: 999999 !important; }';
    document.head.appendChild(style);
  }
}



  // ------- 簡易モーダルのスタイル注入 -------
  const style = document.createElement('style');
  style.textContent = `
  .modal-overlay{position:fixed;inset:0;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.45);z-index:9999;padding:16px;}
  .modal-overlay .modal-card{background:#fff;max-width:560px;width:100%;padding:20px;border-radius:12px;box-shadow:0 10px 30px rgba(0,0,0,.2);}
  .modal-overlay .modal-card p{margin:.5rem 0;}
  .modal-overlay .modal-card .modal-close{margin-top:8px;}
  `;
  document.head.appendChild(style);

  // ------- boot -------
  function boot(){
    initEmailBlock();
    initPhysicalBlock();
    initCheckoutGuard();
    initDatePickersEn();
  }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot); // OS2.0動的再描画に対応
})();
